import { render, staticRenderFns } from "./dataSetChoose.vue?vue&type=template&id=87d24df0&scoped=true"
import script from "./dataSetChoose.vue?vue&type=script&lang=js"
export * from "./dataSetChoose.vue?vue&type=script&lang=js"
import style0 from "./dataSetChoose.vue?vue&type=style&index=0&id=87d24df0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d24df0",
  null
  
)

export default component.exports